const literaryCoordinatorData = [
  {
    name: "Shashank Srivastava",
    contact: "+91 9654726542",
    // course: "B.Tech CSE(AI)",
    image: "Shashank",
  },
  {
    name: "Ansh Srivastava",
    contact: "+91 8840074647",
    // course: "B.Tech CSE(AI)",
    image: "Ansh",
  },
  {
    name: "Ishan Sangal",
    contact: "+91 9458004607",
    // course: "B.Tech CSE(AI)",
    image: "Ishan",
  },
];
export default literaryCoordinatorData;
